import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { PyThreadAuthorLabel } from './styled';
import { useUserContext } from 'providers/UserProvider';
import { useViewerInfo } from 'components/preview/identify-viewer/useViewerInfo';
import { isValidEmail } from 'utils/isValidEmail';

export const ThreadPrivateAuthor = () => {
  const { t } = useTranslation();
  const { data } = useUserContext();

  const getAuthor = () => {
    return data?.fullName || t('comments.anonymous');
  };

  return <PyThreadAuthorLabel>{getAuthor()}</PyThreadAuthorLabel>;
};

export const ThreadPublicAuthor = () => {
  const { t } = useTranslation();
  const { viewer, clearViewerEmail } = useViewerInfo();
  const hasValidEmail = !!(viewer.email && isValidEmail(viewer.email));

  // clearViewerEmail must run as a real side effect, not during render - calling it inline
  // while computing the label triggers a setState while React is still rendering this component.
  useEffect(() => {
    if (!hasValidEmail) {
      clearViewerEmail();
    }
  }, [hasValidEmail, clearViewerEmail]);

  return <PyThreadAuthorLabel>{hasValidEmail ? viewer.email : t('comments.anonymous')}</PyThreadAuthorLabel>;
};
